export default __webpack_public_path__ + "static/media/logo black.3b11879a.png";